import { Arg, CONTAINER_ARGS, Metadata, pick } from '../../../../utils/spds/metadata';
import FlexColumn from '../../layout/flex/column.gjs';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';
import styles from './body.module.scss';

const METADATA = Metadata.define({
  description: 'Body section for full-screen modal.',
  extends: [
    pick(CONTAINER_ARGS, [
      'fitContent',
      'fitContentHeight',
      'fitContentWidth',
      { name: 'column', default: true },
    ]),
  ],
  meta: {
    fill: Arg.boolean({ default: false, description: 'Fill available space' }),
  },
  name: 'Body',
});

export default class SpdsModalFullScreenBody extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-full-screen-body';
  classesToMap = ['fill'];
  styles = styles;

  get column() {
    return this.argOrDefault('column');
  }

  get component() {
    return this.column ? FlexColumn : FlexRow;
  }

  <template>
    <this.component
      @fitContent={{@fitContent}}
      @fitContentHeight={{@fitContentHeight}}
      @fitContentWidth={{@fitContentWidth}}
      @flex="1"
      class={{this.classes}}
      data-test-spds-modal-full-screen-body
      {{this.validateArguments}}
      ...attributes
    >
      {{yield}}
    </this.component>
  </template>
}

export const MODAL_FULL_SCREEN_BODY_METADATA = SpdsModalFullScreenBody.metadata;
